import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
import {delItem} from "../delItem";
import {loaderMixin} from "../utils/loaderMixin";
import {tokenAndRoute} from "../utils/tokenAndRoute";
import {checkedClass} from "../utils/checkedClass";
import delIcon from '../../components/Svg/cart_control/delIcon'
import userIcon from '../../components/Svg/users/user'
import filterIcon from '../../components/Svg/filterIcon'
import {tableComponentMixin} from "../utils/tableComponentMixin";
import {showOverlay} from "../utils/showOverlay";

export const thingRightsControl = {
  mixins: [delItem,loaderMixin,tokenAndRoute,checkedClass, tableComponentMixin, showOverlay],
  components: {
    delIcon,
    userIcon,
    filterIcon
  },
  data() {
    return {
      rolesLength: 0,
      nameUp: true,
      nameDown: true,
      nameFiltered: false,

      mailUp: true,
      mailDown: true,
      mailFiltered: false,

      rightsUp: true,
      rightDown: true,
      rightsFiltered: false,

      checkedUsers: [],
      //table
      clearMarker: false,
      //legend rights(users)
      legendRights: [],
      //width rights
      columnWidthRights: [347/782*100, 308/782*100, 127/782*100],
      //legend roles
      legendRoles: [],
      //width roles
      // columnWidthRoles: [(347 + 308)/782*100, 127/782*100]
      columnWidthRoles: [25, 25, 25, 25]
    }
  },
  computed: {
    ...mapState({
      thing: state => state.things.device,
      allRoles: state => state.projects.allRoles,
      rolesData: state => state.roles.ownedRoles,
      projects: state => state.projects.allProjects
    }),
    ...mapGetters({
      singleItems: 'roles/interfaceSingleItems',
    }),
    columnsRights() {
      return this.thingUsers.map(item => {
        return {
          id: item.id,
          item,
          cells: [
            {
              text: {
                text: `${item.role.owner.first_name ? item.role.owner.first_name : ''} ${item.role.owner.second_name ? item.role.owner.second_name : ''}`,
                isLink: false
              },
              avatar: {
                isAvatar: true,
                avatarLink: item.role.owner.contacts.avatar_url
              }
            },
            {
              text: {
                isLink: true,
                text: item.role.owner.contacts.email,
                link: `mailto:${item.role.owner.contacts.email}`,
                linkColor: false
              },
              avatar: {
                isAvatar: false
              }
            },
            {
              text: {
                text: this.returnPermission(item)
              },
              avatar: {
                isAvatar: false
              }
            }
          ]
        }
      })
    },
    columnsRoles() {
      let userFlag = false;
      let deviceObject;
      let deviceObjectRole = [];

      let deviceFunc = (data) => {
        data.devices.forEach((device) => {
          if (device.id === this.thing.id) {
            deviceObject = device
          }
        })
      }
      let projectFunc = (data) => {
        data.forEach((item) => {
          if (item.devices.length > 0) {
            item.devices.forEach((device) => {
              if (device.id === this.thing.id) {
                deviceObject = device
              }
              if (device.devices.length > 0) {
                deviceFunc(device)
              }
            })
          }
        })
      }
      this.projects.forEach((project) => {
        if (project.items.length > 0) {
          projectFunc(project.items)
        }
      })

      this.singleItems.forEach((singleItem) => {
        deviceObject.permissions.forEach((permission) => {
          if (singleItem.id === permission.role_id) {
            deviceObjectRole.push({singleItem: singleItem, role_id: permission.role_id})
          }
        })
      })

      deviceObjectRole = deviceObjectRole.filter(item => item.singleItem.deleted_at === null)

      this.rolesLength = deviceObjectRole.length

      // console.log(deviceObjectRole)

      return deviceObjectRole.map(item => {
        let roleTags = '';
        let roleObject;

        if (item.singleItem.tags.length > 0) {
          for (let i = 0; i < item.singleItem.tags.length; i++) {
            if (i < 3) {
              roleTags += '<a class="tag">' + item.singleItem.tags[i].name + '</a>';
            }
          }
        } else {
          roleTags = ''
        }

        this.thingUsers.forEach((thingUser) => {
          item.singleItem.users.forEach((user, userIndex) => {
            user.roles.forEach((role, roleIndex) => {
              userFlag = role.role_id === thingUser.role_id && thingUser.role_id === item.role_id;
              if (!userFlag) {
                return
              }
              if (item.singleItem.users.length === userIndex + 1 && userFlag) {
                roleObject = thingUser
              }
            })
          })
        })

        return {
          id: item.singleItem.id,
          item: item.singleItem,
          cells: [
            {
              text: {
                text: item.singleItem.name,
                isLink: true,
                link: `roles/role/${item.singleItem.id}`,
                linkColor: false,
                isTrimmed: true,
                // trimWidth: 50
                trimWidth: 1
              },
              avatar: {
                isAvatar: false
              }
            },
            {
              text: {
                text: ''
              },
              tagsArray: roleTags,
              isLinksTags: true,
              avatar: {
                isAvatar: false,
              }
            },
            {
              text: {
                text: this.returnPermission(roleObject)
              },
              avatar: {
                isAvatar: false,
              }
            },
            {
              text: {
                text: ''
              },
              usersArray: this.returnUsersData(item.singleItem),
              avatar: {
                isAvatar: false,
              }
            }
          ]
        }
      })
    },
    allChecked() {
      if (this.columnsRoles) {
        return this.checkedUsers.length === this.columnsRoles.length && this.checkedUsers.length > 0
      } else {
        return false
      }
    },
  },
  watch: {
    thing(val) {
      this.checkedUsers = [];
      this.removeCheckedClass('right-item_checked')
    }
  },
  methods: {
    ...mapMutations({
      showRightsControl: 'things/SET_RIGHTS_CONTROL',
      setDefaultRight: 'things/SET_DEFAULT_VAL_RIGHTS',
      setRightsType: 'things/SET_RIGHTS_TYPE',
      setRightsDeviceType: 'things/SET_RIGHTS_DEVICE_TYPE'
    }),
    ...mapActions({
      setPermissions: 'things/setPermissions',
      removePermission: 'things/removePermission',
      getProjects: 'projects/getProjects',
      getThing: 'things/getDevice'
    }),
    createLegendRights() {
      return this.legendRights = [
        {
          text: this.$t('users.table.contactPerson'),
          legendSort: true,
          legendDown: true,
          legendUp: true,
          activeFilter: false,
          filterMethod: 'filterName'
        },
        {
          text: this.$t('users.table.email'),
          legendSort: true,
          legendDown: true,
          legendUp: true,
          activeFilter: false,
          filterMethod: 'filterMail'
        },
        {
          text: this.$t('labels.rights'),
          legendSort: true,
          legendDown: true,
          legendUp: true,
          activeFilter: false,
          filterMethod: 'filterRights'
        }
      ]
    },
    createLegendRoles() {
      return this.legendRoles = [
        {
          text: 'Название роли',
          legendSort: true,
          legendDown: true,
          legendUp: true,
          activeFilter: false,
          filterMethod: 'filterName'
        },
        {
          text: 'Теги роли',
          legendSort: true,
          legendDown: true,
          legendUp: true,
          activeFilter: false,
          filterMethod: 'filterName'
        },
        {
          text: 'Права доступа роли',
          legendSort: true,
          legendDown: true,
          legendUp: true,
          activeFilter: false,
          filterMethod: 'filterName'
        },
        {
          text: 'Пользователи роли',
          legendSort: true,
          legendDown: true,
          legendUp: true,
          activeFilter: false,
          filterMethod: 'filterName'
        }
      ]
    },
    returnUsersData(item) {
      return item.users.map(item => {
        return {
          avatar: item.contacts.avatar_url,
          first_name: item.first_name,
          second_name: item.second_name
        }
      })
    },
    filterName(index,legendName) {
      this.copyLegend(legendName);
      this.setDefaultLegend();
      this.setActiveFilterLegend(index);

      this.mailUp = true;
      this.mailDown = true;
      this.rightDown = true;
      this.rightsUp = true;
      this.nameFiltered = true;
      this.mailFiltered = false;
      this.rightsFiltered = false;

      if (this.nameUp && this.nameDown) {
        this.nameUp = true;
        this.nameDown = false;
        this.setLegendUp(index);
        this.setLegendArr(legendName);
        return
      };

      if (this.nameUp) {
        this.nameDown = true;
        this.nameUp = false;
        this.setLegendDown(index);
        this.setLegendArr(legendName);
        return
      };

      if (this.nameDown) {
        this.nameUp = true;
        this.nameDown = false;
        this.setLegendUp(index);
        this.setLegendArr(legendName);
        return
      }
    },
    filterMail(index,legendName) {
      this.copyLegend(legendName);
      this.setDefaultLegend();
      this.setActiveFilterLegend(index);
      this.nameUp = true;
      this.nameDown = true;
      this.rightDown = true;
      this.rightsUp = true;
      this.mailFiltered = true;
      this.nameFiltered = false;
      this.rightsFiltered = false;

      if (this.mailUp && this.mailDown) {
        this.mailUp = true;
        this.mailDown = false;
        this.setLegendUp(index);
        this.setLegendArr(legendName);
        return
      };

      if (this.mailUp) {
        this.mailDown = true;
        this.mailUp = false;
        this.setLegendDown(index);
        this.setLegendArr(legendName);
        return
      };

      if (this.mailDown) {
        this.setLegendUp(index);
        this.setLegendArr(legendName);
        this.mailUp = true;
        this.mailDown = false;
        return
      }
    },
    filterRights(index,legendName) {
      this.copyLegend(legendName);
      this.setDefaultLegend();
      this.setActiveFilterLegend(index);
      this.nameUp = true;
      this.nameDown = true;
      this.mailDown = true;
      this.mailUp = true;
      this.rightsFiltered = true;
      this.nameFiltered = false;
      this.mailFiltered = false;

      if (this.rightsUp && this.rightDown) {
        this.rightsUp = true;
        this.rightDown = false;
        this.setLegendUp(index);
        this.setLegendArr(legendName);
        return
      };

      if (this.rightsUp) {
        this.rightDown = true;
        this.rightsUp = false;
        this.setLegendDown(index);
        this.setLegendArr(legendName);
        return
      };

      if (this.rightDown) {
        this.rightsUp = true;
        this.rightDown = false;
        this.setLegendUp(index);
        this.setLegendArr(legendName);
        return;
      }
    },
    checkItem(e) {
      let arr = this.checkedUsers.slice();
      let input = e.target;
      let item = input.parentElement.parentElement.parentElement;
      this.toggleClass(item, 'right-item_checked')
    },
    returnPermission(user) {
      if (user) {
        switch (user.value) {
          case(1): return this.$t('things.per1');
            break;
          case(2): return `${this.$t('things.per1')}, ${this.$t('things.per2')}`
            break;
          case(3): return `${this.$t('things.per1')}, ${this.$t('things.per2')}, ${this.$t('things.per3')}`
        }
      }
    },
    roleObj(id) {
      return this.allRoles.filter(role => {
        if(role.id == id) {
          return role;
        }
      });
    },
    checkAll() {
      if (this.allChecked) {
        this.checkedUsers = []
      } else {
        this.checkedUsers = []
        this.columnsRoles.forEach(item => {
          this.checkedUsers.push(item.item)
        })
      }
    }
  }
};
